import Value from './FeaturedHousesSection'

export default {
	label: 'Featured houses',
	group: 'slider',
	Value,
}
